import React from 'react';
import { Star, ArrowUpToLine, Zap, Home } from 'lucide-react';

// Selos comerciais (Fase 3 · Bloco A). Discretos: identificam promoção paga,
// nunca sugerem avaliação ou recomendação do Marketplace.
const BADGES = {
  destaque: { label: 'Destacado', icon: Star, cls: 'bg-amber-50 text-amber-800 ring-amber-200' },
  topo: { label: 'No topo', icon: ArrowUpToLine, cls: 'bg-sky-50 text-sky-800 ring-sky-200' },
  urgente: { label: 'Urgente', icon: Zap, cls: 'bg-rose-50 text-rose-700 ring-rose-200' },
  destaque_homepage: { label: 'Em destaque', icon: Home, cls: 'bg-violet-50 text-violet-800 ring-violet-200' },
  destaque_categoria: { label: 'Destaque na categoria', icon: Star, cls: 'bg-amber-50 text-amber-800 ring-amber-200' },
};

export const hasPromo = (promocoes, key) => (promocoes || []).includes(key);

export default function PromoBadges({ promocoes = [], size = 'sm', testIdPrefix = 'promo' }) {
  const list = (promocoes || []).filter((p) => BADGES[p]);
  if (!list.length) return null;
  const pad = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  return (
    <div className="flex flex-wrap items-center gap-1" data-testid={`${testIdPrefix}-badges`}>
      {list.map((key) => {
        const b = BADGES[key];
        const Icon = b.icon;
        return (
          <span
            key={key}
            className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wide ring-1 ${b.cls} ${pad}`}
            data-testid={`${testIdPrefix}-badge-${key}`}
            title="Promoção comercial paga pelo anunciante"
          >
            <Icon className="h-3 w-3" /> {b.label}
          </span>
        );
      })}
    </div>
  );
}
